import { formatToTRY } from '../../utils';

export type ProposalAmountValue = number | string | null | undefined;

export const formatProposalAmount = (value: ProposalAmountValue): string => {
  if (value === null || value === undefined || (typeof value === 'string' && value.trim() === '')) {
    return '-';
  }

  const amount = Number(value);
  return Number.isFinite(amount) ? `${formatToTRY(amount, false)} TL` : '-';
};
